import { api } from './client';
import type { Page } from './catalogs';

export type TransferDirection = 'TO_BUYER' | 'FROM_SUPPLIER';
export type ReturnDirection = 'FROM_BUYER' | 'TO_SUPPLIER';

export interface TareItem {
  line_number: number;
  nomenclature_id: string;
  quantity: string;
  deposit_price: string;
  amount: string;
}

export interface TareItemOut extends TareItem {
  id: string;
}

export interface TareTransferListItem {
  id: string;
  document_number: string;
  document_date: string;
  contractor_id: string;
  direction: string;
  total_amount: string;
  state: string;
  posted: boolean;
  external_source?: string | null;
}

export interface TareTransferCreate {
  organization_id: string;
  contractor_id: string;
  contract_id?: string | null;
  document_number?: string | null;
  document_date: string;
  direction: TransferDirection;
  comment?: string | null;
  items: TareItem[];
}

export interface TareReturnCreate {
  organization_id: string;
  contractor_id: string;
  contract_id?: string | null;
  document_number?: string | null;
  document_date: string;
  direction: ReturnDirection;
  base_document_type?: string | null;
  base_document_id?: string | null;
  comment?: string | null;
  items: TareItem[];
}

export const tareTransfers = {
  list: (params?: { organization_id?: string; limit?: number; offset?: number }) =>
    api.get<Page<TareTransferListItem>>('/tare-transfers', { params }).then((r) => r.data),
  get: (id: string) => api.get(`/tare-transfers/${id}`).then((r) => r.data),
  create: (p: TareTransferCreate) =>
    api.post('/tare-transfers', p).then((r) => r.data),
  update: (id: string, p: Partial<TareTransferCreate>) =>
    api.patch(`/tare-transfers/${id}`, p).then((r) => r.data),
  remove: (id: string) => api.delete(`/tare-transfers/${id}`).then(() => undefined),
  post: (id: string) => api.post(`/tare-transfers/${id}/post`).then((r) => r.data),
  unpost: (id: string) => api.post(`/tare-transfers/${id}/unpost`).then((r) => r.data),
};

export const tareReturns = {
  list: (params?: { organization_id?: string; limit?: number; offset?: number }) =>
    api.get<Page<TareTransferListItem>>('/tare-returns', { params }).then((r) => r.data),
  get: (id: string) => api.get(`/tare-returns/${id}`).then((r) => r.data),
  create: (p: TareReturnCreate) =>
    api.post('/tare-returns', p).then((r) => r.data),
  update: (id: string, p: Partial<TareReturnCreate>) =>
    api.patch(`/tare-returns/${id}`, p).then((r) => r.data),
  remove: (id: string) => api.delete(`/tare-returns/${id}`).then(() => undefined),
  post: (id: string) => api.post(`/tare-returns/${id}/post`).then((r) => r.data),
  unpost: (id: string) => api.post(`/tare-returns/${id}/unpost`).then((r) => r.data),
};
